(function(){

    'use strict';

    let deleteButtons = document.querySelectorAll('.delete-account');
    let modal = document.querySelector('.modal');

    for (let deleteButton of deleteButtons) {
        deleteButton.addEventListener('click', (event) => {
            event.preventDefault();
            modal.classList.toggle('hidden');
        });
    }
}());
